import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SubscriptionStateService } from '@app/core/services';
import { map } from 'rxjs';

/**
 * Rutas de ESCRITURA (`/app/new-chat`): con la suscripción vencida no se entra,
 * se manda a `/billing`, que es donde está el remedio.
 *
 * Antes este guard cerraba también el listado y el chat, y lo hacía mal: el 403
 * de `check-subscription` llegaba como error al router, la navegación se
 * cancelaba en silencio y el profesional se quedaba donde estaba sin saber por
 * qué. Ahora redirige con un `UrlTree`.
 *
 * «No se sabe» (`null`: red caída, 5xx) deja pasar: el backend sigue exigiendo la
 * suscripción al crear la sesión, y una caída no debe parecer una cuenta vencida.
 */
export const subscriptionGuard: CanActivateFn = () => {
	const router = inject(Router);
	return inject(SubscriptionStateService)
		.refresh()
		.pipe(
			map(active =>
				active === false ? router.createUrlTree(['/billing']) : true
			)
		);
};

/**
 * Rutas de LECTURA (`/app/chats-list`, `/app/chat/:id`): se abren siempre —
 * decisión 4 del 5-oct, con la suscripción vencida se pueden ver y exportar las
 * sesiones—, pero antes se refresca el estado para que la pantalla sepa si tiene
 * que ir en solo lectura.
 */
export const subscriptionStatusGuard: CanActivateFn = () =>
	inject(SubscriptionStateService)
		.refresh()
		.pipe(map(() => true));
